import * as React from 'react';
import { IgcStepperComponent as Component } from 'igniteui-webcomponents';
import type { IgcStepperComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A stepper component that provides a wizard-like workflow by dividing content into logical steps.
 * @slot  - Renders `igc-step` components inside the default slot.
 * @fires igcActiveStepChanging - Emitted when the active step is about to change. Cancelable.
 * @fires igcActiveStepChanged - Emitted after the active step has changed.
 * @class
 */
export const IgrStepper = /* @__PURE__ */ createComponent({
  tagName: 'igc-stepper',
  displayName: 'IgrStepper',
  elementClass: Component,
  react: React,
  events: {
    onActiveStepChanging: 'igcActiveStepChanging' as EventName<
      IgcStepperComponentEventMap['igcActiveStepChanging']
    >,
    onActiveStepChanged: 'igcActiveStepChanged' as EventName<
      IgcStepperComponentEventMap['igcActiveStepChanged']
    >,
  },
});

export type IgrStepper = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrStepperModule = Component;
